<template>

  <div>
    <h4 class="mb-4">{{ $t('Select the entity to start the report') }}</h4>
    <div
      class="list-group">
      <!--<a
        href="javascript:void(0)"
        @click="change('diversity')"
        class="list-group-item list-group-item-action">
        <h5 class="mb-2">{{ $t('Diversity') }}</h5>
      </a>-->
      <a
        href="javascript:void(0)"
        @click="change('placements')"
        class="list-group-item list-group-item-action">
        <h5 class="mb-2">{{ $t('Candidates in the pipeline') }}</h5>
        <p class="mb-0">Extraia insights dos candidatos no processo seletivo como: tempo para contratar, candidatos por etapas, número de contratados entre outros.</p>
      </a>
      <a
        href="javascript:void(0)"
        @click="change('jobs')"
        class="list-group-item list-group-item-action">
        <h5 class="mb-2">{{ $t('Jobs') }}</h5>
        <p class="mb-0">Obtenha informações das vagas como: postos abertos no período, vagas por responsável entre outras.</p>
      </a>
      <a
        href="javascript:void(0)"
        @click="change('candidates')"
        class="list-group-item list-group-item-action">
        <h5 class="mb-2">{{ $t('Candidates') }}</h5>
        <p class="mb-0">Extraia insights de candidatos como: total de candidatos cadastrados ou origem dos candidatos.</p>
      </a>
      <a
        href="javascript:void(0)"
        @click="change('moves')"
        class="list-group-item list-group-item-action">
        <h5 class="mb-2">{{ $t('Movements in the pipeline') }}</h5>
        <p class="mb-0">Obtenha informações da pipeline como: conversões de candidatos por etapa ou tempo médio dos candidatos em cada etapa.</p>
      </a>
      
      <a
        href="javascript:void(0)"
        @click="change('events')"
        class="list-group-item list-group-item-action">
        <h5 class="mb-2">{{ $t('Events') }}</h5>
        <p class="mb-0">Extraia insights de agendamentos como: Eventos por participante ou eventos por mês.</p>
      </a>

      <!-- <a
        href="javascript:void(0)"
        @click="change('activities')"
        class="list-group-item list-group-item-action">
        <h5 class="mb-2">{{ $t('Activities') }}</h5>
        <p class="mb-0">Extraia insights de produtividade por meio de atividades como agendamentos, avaliações, e-mails por recrutador ou global.</p>
      </a> -->
    </div>
  </div>

</template>

<script>
export default {
  name: 'ReportModules',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    change (mod) {
      this.$emit('change', mod)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DashcomponentFormModules.vue